import Svg, { Circle, Path } from "react-native-svg";
import type { SvgProps } from "react-native-svg";
import { memo } from "react";
const SvgIconWarning = (props: SvgProps) => <Svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} fill="none" viewBox="0 0 40 40" {...props}><Circle cx={15} cy={15.5} r={15} fill="currentColor" /><Path stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth={4} d="M15 6.5v11" /><Circle cx={15} cy={23.5} r={2} fill="white" /></Svg>;
const Memo = memo(SvgIconWarning);
export default Memo;